// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_WHERE_IS_DISCUSSED = "Kde sa diskutuje";
export const HOME_RIGHT_LATEST_REVIEWS = "Najnov\u0161ie hodnotenia";
export const HOME_RIGHT_MORE_REVIEWS = "\u010eal\u0161ie hodnotenia...";
